module.exports = __webpack_public_path__ + "img/643.5630d11a.png";